module.exports = __webpack_public_path__ + "static/img/bg_en.ace8285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/24-hour-2026-sale/bg_en.png
// module id = 8eBA
// module chunks = 2